export const local_storage_keys = {
  PAY_IN_AMOUNT: 'pay_in_amount',
};
